(function() {
  // Check if dark mode is active
  function isDark() {
    const saved = localStorage.getItem('theme');
    if (saved) return saved === 'dark';
    return window.matchMedia('(prefers-color-scheme: dark)').matches;
  }

  // Apply theme to all existing buttons
  function applyTheme(dark) {
    document.documentElement.setAttribute('data-theme', dark ? 'dark' : 'light');

    const themeToggleBtn = document.querySelectorAll('.theme-toggle');
    themeToggleBtn.forEach(button => {
      const sunIcon = button.querySelector('.icon-sun');
      const moonIcon = button.querySelector('.icon-moon');
      if (sunIcon && moonIcon) {
        sunIcon.style.display = dark ? 'none' : 'inline-block';
        moonIcon.style.display = dark ? 'inline-block' : 'none';
      }
    });
  }

  // Toggle theme
  function toggleTheme() {
    const dark = !isDark();
    localStorage.setItem('theme', dark ? 'dark' : 'light');
    applyTheme(dark);
  }

  // Use event delegation on document
  document.addEventListener('click', function(e) {
    if (e.target.closest('.theme-toggle')) {
      toggleTheme();
    }
  });

  // Initialize
  applyTheme(isDark());

  // Watch for new elements and apply current theme
  const observer = new MutationObserver(function() {
    applyTheme(isDark());
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
})();